// Generated from /builds/tableau-expression/tableau-expression-parser-js/build/nerv-resources/resources/TableauExpression.g4 by ANTLR 4.12.0
import { ParseTreeListener } from "antlr4";
/**
 * This interface defines a complete listener for a parse tree produced by
 * `TableauExpressionParser`.
 */
export default class TableauExpressionListener extends ParseTreeListener {
}
//# sourceMappingURL=TableauExpressionListener.js.map